import PropTypes from "prop-types"
import React from "react"

import Badge from "src/components/Badge"
import { statusToken } from "src/components/Badge/status_tokens"
import Tooltip from "src/components/Tooltip"

const RevenueMappingStatus = ({ status, message }) => (
  <Tooltip
    text={
      <>
        <span className="block font-semibold">{status}</span>
        {message}
      </>
    }
    placement="right"
    variant="dark"
    maxWidth="400px"
    tabIndex={0}
  >
    <span className="flex items-center">
      <span aria-hidden="true">
        <Badge
          color={statusToken(status)}
          text={status}
          icon="circle-info"
          iconStyle="solid"
          iconPlacement="right"
        />
      </span>
      <span className="sr-only">{`${status}. ${message}`}</span>
    </span>
  </Tooltip>
)

RevenueMappingStatus.propTypes = {
  status: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
}

export default RevenueMappingStatus
